<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img: '@/assets/four.jpg',
    }
  },

}
</script>
<style lang="less">
[v-cloak] {
  display: none !important;
}

// 公共样式部分
div, ul, li, a, p, html, h1, h2, h3, h4, h5, h6, span, body {
  padding: 0;
  margin: 0;
  font-family: "font-family: Source Han Sans CN"
}

body, html, #app {
  height: 100%;
  //overflow: auto;
  // background-color:red;
}

.row-top {
  margin-top: 20px;
}

.input {
  span {
    font-size: 30px;

    > i {
      line-height: 78px;

    }
  }
}

.input.el-input--prefix .el-input__inner {
  height: 100%;
  border-radius: 0;
  font-size: 22px;
  color: #343434;
  padding-left: 40px;
}

.content-left .inp .el-input__inner {
  border-radius: 0;
}

.code .input .el-input__prefix .el-input__icon {
  transform: rotateZ(220deg) translateX(-6px);
}

// 我的资料公司福利
.tip {
  margin: 0 3px;
}

// 审核管理详情按钮
.btn-list {
  margin-top: 50px;
}


//左侧菜单栏
.menu.el-menu-vertical-demo.el-menu {
  width: 100%;
  text-align: center;

  .el-menu-item-group .el-menu-item {
    padding-left: 43% !important;
    text-align: left;
  }

}

//  底部分页按钮样式
.nomore .page.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1A80FC;
}

// 文章图片上传
.article-img {
  .el-upload {
    width: 100%;
    height: 100%;
  }
}

// 图片上传
.update-img .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 110px;
  background-color: #EEF2FB;
  border: none;
}

.update-img .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}

// 面试管理卡片样式
.interview-card.box-card .el-card__body {
  padding: 0;
}

// 修改表格编辑弹框
.compile-box {
  .el-dialog__header {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 30px;
  }

}

// 选择职位样式
// .job-inp.el-select>.el-input{
//   width:40%;
//   display:inline-block;
// }

// 我的资料中的公司logo
.company-logo.el-avatar > img {
  width: 100%;
}

// 权限设置编辑弹框checkbox样式更改
.complie-form {
  .jurisdiction .el-form-item__content {
    padding-top: 5px;
    line-height: 30px;
    max-height: 237px;
    overflow-y: scroll;
  }
}

// 更改面试管理卡片样式
.interview-card .el-card__body {
  height: 220px;
}

//  日期选择器样式修改
.data-inp.el-input__inner {
  background-color: #EEF2FB;
  // .el-range-separator{
  //   background-color:#EEF2FB
  // }
}

// 选择input框样式
.select-inp.el-input.is-disabled .el-input__inner {
  color: #606266;
}

//  修改表格样式
.table-content {

  .el-table__body,
  .el-table__header-wrapper {
    border-collapse: separate;
    border-spacing: 0px 30px;

    tr, th {
      background-color: #EAF3FF;
    }

    tr:hover {
      //  background-color:red;;
    }
  }

  .el-table__header {
    margin-top: 30px;
  }
}

//主题背景颜色
.theme-bg {
  background-color: #EEF2FB;
}

// 主题button颜色
.theme-btn {
  background: #1A80FC !important;
  border: none !important;
}

// 主题文本框背景颜色修改
.text-bg input,
.text-bg textarea,
.text-bg.el-textarea .el-input__count {
  background-color: #EEF2FB;
}

// 单选按钮样式修改
.check-btn .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #1A80FC;
  border-color: #1A80FC;
}

// 定义input框、textarea的焦点
.define-inp .el-input__inner,
.define-inp .el-textarea__inner {
  border: none;
  outline: none;
  cursor: default;
}

// 我的资料中验证码文本框
.code-inp {
  .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

//  更改textarea的能否伸缩性
.checkText .el-textarea__inner {
  resize: none;
}

// 横线
.line.el-divider--horizontal {
  margin: 13px 0px;
  background-color: #e6ecf8;
}

// 更改card
.set-card .el-card__body {
  padding: 0;
}

.set-pd.el-row.info-item {
  padding: 10px 40px;

}

// 油田
.fild {
  .el-form-item__content {
    line-height: 0;
  }

  .el-upload.el-upload--text {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}


//  灵活就业发布中的头像设置
.userImag {
  img {
    width: 100%;
  }
}

// 设置聊天输入框的textarea
.chat-input .input .inpt .el-textarea__inner {
  width: 100%;
  height: 100%;
  border: none;
  resize: none;
}

.chat-input .input .inpt .el-textarea__inner:focus {
  border: none;
  outline: none;
}


// 发送面试邀请弹框
.alert {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 20px;
  }
}


// 警告弹框
.warning .el-dialog__footer {
  padding: 0;
}


#app {
  // width:1200px;
  // margin:0 auto;
  background-color: #E6ECF8;
  // #home,#nav{
  //   height:1080px

  // }
}

.el-submenu .el-submenu__title {
  font-size: 16px;
}

li {
  list-style: none;
}

// 清除浮动
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.ts-inp.el-input.is-disabled .el-input__inner,
.ts-inp.el-input.is-disabled .el-input__icon {
  cursor: pointer;
}


//审核管理/企业认证/社会统一代码
.code {

  .el-form-item__label {
    white-space: pre-line;
    text-align: right;
    line-height: 18px;

  }

  //如果是table的话就
  .el-table .cell {
    white-space: pre-line;
  }
}


// 导航部分
#nav {
  height: 100vh;

  .el-menu-item {
    font-size: 16px;
    font-family: "Source Han Sans CN";
    font-weight: 400;
    color: #616779;
  }
}

.tac {
  background-color: #25272F;
  font-size: 8px;
  height: 100%;
}

.title {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: 500;
  color: #197FFB;
  line-height: 60px;
  text-align: center;
}

.image-box {
  text-align: center;
  margin-bottom: 20px;

  .image {
    width: 68px;
    height: 68px;
    margin: 0 auto;
    border-radius: 50%;
    background: url('../src/assets/four.jpg') 100% 100% no-repeat;
  }

  span {
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
  }
}

.el-submenu .el-menu-item-group .el-menu-item {
  min-width: 100%;
}

// 文章发布-添加文章输入框样式更改
.inp-color .el-input__inner {
  color: #1A80FC;
  font-size: 16px;
}


// 富文本编辑器部分
// .rich-text-box{
//   background-color:red;
// }
.rich-text-box {
  .ql-container.ql-snow,
  .ql-toolbar.ql-snow {
    border: none;
  }

}


//  head部分

// .head{
//     height:60px;
//     background-color:#ffffff;
//     // background-color:red;
//     .job{
//         font-size: 18px;
//         font-family: "Source Han Sans CN";
//         font-weight: 400;
//         color: #333333;
//         line-height: 60px;
//     }


//     .personal-zl{
//         height:60px;
//         // background-color:red;
//         line-height:60px;
//             .img{
//                 width: 40px;
//                 height: 40px;
//                 display:inline-block;
//                 vertical-align:middle;
//                 background: #4E72C8;
//                 border-radius: 50%;
//                 background:url("./assets/four.jpg") 100% 100% no-repeat;
//             }
//             .personal{
//                 margin-left:6px;
//                 font-size: 14px;
//                 font-family: "Source Han Sans CN";
//                 font-weight: 400;
//                 color: #333333;
//                 line-height: 60px;
//                 cursor:pointer;
//             }
//             .info{
//                 margin-left:10px;
//             }
//             .icon{
//                 font-size:27px;
//                 line-height:60px;
//                 cursor:pointer;
//                 color:#333333;
//             }
//             .log-out{
//                 position:relative;
//                 bottom:3px;
//             }

//     }

// }
</style>
